import React, { useEffect, useState } from 'react';
import colors from '../../../Utils/colors';
import {
    createInvoice,
    createPaymentSubscription,
    newSignUp,
    paymentOrder,
    sendAgentOTPV2,
    sendEmailOTPV2,
    sendOTP_V3,
    sendUserOTPV2,
    userLogin,

} from '../../../Services';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import images from '../../../Utils/images';
import CheerioButton from '../../../Components/CheerioButton';
import { TextField } from '@mui/material';
import { Modal, Button, Form, Card, ListGroup } from 'react-bootstrap';
import PremiumSucess from './PremiumSuccess';
import './style.css';

const mobileWidth = window.innerWidth < 700 ? true : false;

const PremiumModal = ({ setShowPremiumModal, showPremiumModal, planName, planDuration, currency }) => {
    const auth_token = useSelector((state) => state.main?.auth_token);

    const planDetails = [
        // {name: "Basic", duration: "Quarterly", priceINR: '4,500', priceUSD: '56', INRID: 'plan_OBsrkWdl90hiYZ', USDID: 'plan_OSAQhGj7slsjPf'},
        {
            name: 'Basic',
            duration: 'Quarterly',
            priceINR: '4,500',
            priceUSD: '56',
            INRID: 'plan_OyCNaABf59WSMO',
            USDID: 'plan_OSAQhGj7slsjPf',
        },
        {
            name: 'Startup',
            duration: 'Quarterly',
            priceINR: '8,997',
            priceUSD: '102',
            INRID: 'plan_RCcWgSsBbQNq8z',
            USDID: 'plan_RCcWhjAlwTWb4g',
        },
        {
            name: 'Growth',
            duration: 'Quarterly',
            priceINR: '23,997',
            priceUSD: '276',
            INRID: 'plan_RCcWiPnGg8RMeF',
            USDID: 'plan_RCcWj1rIwvmwGV',
        },
        {
            name: 'Pro',
            duration: 'Quarterly',
            priceINR: '41,997',
            priceUSD: '483',
            INRID: 'plan_RCcWjgOW1X4Qpa',
            USDID: 'plan_RCcWkHfgllh9G4',
        },
        {
            name: 'Enterprise',
            duration: 'Quarterly',
            priceINR: '70,000',
            priceUSD: '875',
            INRID: 'plan_OyCRqbjVLaR3QG',
            USDID: 'plan_OSAVJLbMULJTU4',
        },
        {
            name: 'Basic',
            duration: 'Half-Yearly',
            priceINR: '7,500',
            priceUSD: '94',
            INRID: 'plan_OyCTRCXBKTIvg0',
            USDID: 'plan_OTJfFLMqpOMMQW',
        },
        {
            name: 'Startup',
            duration: 'Half-Yearly',
            priceINR: '14,994',
            priceUSD: '168',
            INRID: 'plan_RCcWcUW2c0YTqR',
            USDID: 'plan_RCcWd4CY3bJGpQ',
        },
        {
            name: 'Growth',
            duration: 'Half-Yearly',
            priceINR: '35,994',
            priceUSD: '414',
            INRID: 'plan_RCcWderqAGY0gG',
            USDID: 'plan_RCcWeH7s3CrrwO',
        },
        {
            name: 'Pro',
            duration: 'Half-Yearly',
            priceINR: '71,994',
            priceUSD: '834',
            INRID: 'plan_RCcWexzUKfrF2C',
            USDID: 'plan_RCcWfbIHJ0B0sz',
        },
        {
            name: 'Enterprise',
            duration: 'Half-Yearly',
            priceINR: '120,000',
            priceUSD: '1,500',
            INRID: 'plan_OyCWsK02DtUGGj',
            USDID: 'plan_OTJvKy4q6aMBqm',
        },
        {
            name: 'Basic',
            duration: 'Yearly',
            priceINR: '12,000',
            priceUSD: '150',
            INRID: 'plan_OyCXxb0OQKcuF2',
            USDID: 'plan_OTK3czSgCcIbtT',
        },
        {
            name: 'Startup',
            duration: 'Yearly',
            priceINR: '23,988',
            priceUSD: '276',
            INRID: 'plan_RCcWYGLTVGVr3V',
            USDID: 'plan_RCcWYuLMHvUP83',
        },
        {
            name: 'Growth',
            duration: 'Yearly',
            priceINR: '59,988',
            priceUSD: '684',
            INRID: 'plan_RCcWZdMRFVboPl',
            USDID: 'plan_RCcWaP9V0zBm5c',
        },
        {
            name: 'Pro',
            duration: 'Yearly',
            priceINR: '1,19,988',
            priceUSD: '1380',
            INRID: 'plan_RCcWb58fcIoiQ0',
            USDID: 'plan_RCcWbq7o6uSlE2',
        },
        {
            name: 'Enterprise',
            duration: 'Yearly',
            priceINR: '200,000',
            priceUSD: '2,500',
            INRID: 'plan_OyCc4AbjOyMslf',
            USDID: 'plan_OTKBhayTDmzmth',
        },
    ];

    const [authToken, setAuthToken] = useState('');

    const [selectedPlan, setSelectedPlan] = useState(null);

    const [ModalOpen, setModalOpen] = useState(false);

    const [subscriptionId, setSubscriptionId] = useState();

    // function getQueryParam(param) {
    //     let url = new URL(window.location.href);
    //     return url.searchParams.get(param);
    // }

    // useEffect(() => {
    //     // const planName = getQueryParam('planName');
    //     // const planDuration = getQueryParam('planDuration');
    //     // const currency = getQueryParam('currency');
    //     setPlanName(getQueryParam('planName'));
    //     setPlanDuration(getQueryParam('planDuration'));
    //     setCurrency(getQueryParam('currency'));
    //     // console.log("params received ---> ",planName,planDuration,currency)
    // }, []);

    useEffect(() => {
        if (planName && planDuration && currency) {
            setSelectedPlan(
                planDetails.filter((item) => item?.name == planName && item?.duration == planDuration)[0]
            );
        }
    }, []);

    const handleClose = () => setShowPremiumModal(false);
    const planPriceINR = Number(selectedPlan?.priceINR.replace(/,/g, ""));
    const planPriceUSD = Number(selectedPlan?.priceUSD);

    function loadScript(src) {
        return new Promise((resolve) => {
            const script = document.createElement('script');
            script.src = src;
            script.onload = () => {
                resolve(true);
            };
            script.onerror = () => {
                resolve(false);
            };
            document.body.appendChild(script);
        });
    }
    let planId = currency == 'INR' ? selectedPlan?.INRID : selectedPlan?.USDID;



    useEffect(() => {
        console.log('subscriptionid', subscriptionId);
    }, [subscriptionId])

    // useEffect(() => {
    //     if (authToken && selectedPlan && auth_token) {
    //         displayRazorpaySubscription(planId, null);
    //     }
    // }, [authToken, selectedPlan]);


    async function displayRazorpaySubscription(planID) {
        console.log('1111111111 ', auth_token);
        console.log('1111111 1 ', planID);

        const res = await loadScript('https://checkout.razorpay.com/v1/checkout.js');

        if (!res) {
            alert('Razorpay SDK failed to load. Are you online?');
            return;
        }

        const jsonPlan = {
            plan: planName,
            planId: planID,
            planDuration: planDuration,
        };
        console.log({ jsonPlan });

        // Show loading toast
        const toastId = toast.loading('Fetching the Payment link');

        let data = {};
        try {
            data = await paymentOrder(jsonPlan, auth_token);
            console.log({ data });
            setSubscriptionId(data?.response?.subscriptionId);

            const options = {
                key: 'rzp_live_1IEjlHGI3q0yMR',
                subscription_id: data?.response?.subscriptionId,
                name: 'Cheerio',
                description: 'Premium',
                handler: function (response) {
                    toast.dismiss(toastId);
                    setModalOpen(true);
                },
                // modal: {
                //     ondismiss: () => {
                //         toast.dismiss(toastId);
                //     },
                // },
            };

            const paymentObject = new window.Razorpay(options);
            paymentObject.open();

            setTimeout(() => {
                toast.dismiss(toastId);
            }, 1000);

            if (data?.flag) {
            }

        } catch (error) {
            toast.dismiss(toastId);
            toast.error('Something went wrong while preparing payment.');
            console.error('Error initiating payment:', error);
        }
    }

    async function generateInvoice(subscriptionId) {
        try {
            let data = {
                plan: subscriptionId,
            };
            let token = auth_token;
            const response = await createInvoice(data, token);
            window.open(response?.response?.data, '_blank');
            // navigate('/creator');
        }
        catch (err) {
            toast.error('Unexpected error occurred, contact our support for help')
            console.log(err);
        }
    }

        return (
            <>

            <Modal show={showPremiumModal} onHide={handleClose} size="xl" centered>
                <img
                src={images.CMClose}
                style={{
                    cursor: 'pointer',
                    height: 22,
                    width: 22,
                    marginLeft: '97%',
                    marginTop: 8
                }}
                onClick={handleClose}
                ></img>
                <Modal.Body>
          <div className="row">
            {/* Left Section */}
            <div className="col-md-6 p-4"

              style={{

                marginTop: "-35px"
              }}>
              <img
                style={{ width: 162, height: 32, marginBottom: 20 }}
                src={images.CheerioAILogo}
                alt="logo"
              />
              <h4 style={{ color: colors.primary03, fontWeight: "600" }}>
                You’re few steps away to invest in best marketing tool for your Business
              </h4>
              <p className="mt-2 text-muted">Here are few things to know before getting started</p>
              <p className="mt-3" style={{ fontSize: 16, fontWeight: 400 }}>You must have admin access to your meta business manager</p>
              <ul style={{ paddingLeft: 22 }}>
                <li style={listTextStyle}>Make sure you have an official business website to proceed smoothly.</li>
                <li style={listTextStyle}>
                  <p>
                    Learn about allowed businesses in{' '}
                    <a
                      href="https://business.whatsapp.com/policy"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#666666", textDecoration: 'underline', cursor: 'pointer' }}
                    >
                      WhatsApp Commerce Policy
                    </a>
                  </p>

                </li>
                <li style={listTextStyle}>If your Meta Business Manager is not verified</li>
                <li style={listTextStyle}>You can send proactive messages to only 50 unique contacts every 24 hours.</li>
                <li style={listTextStyle}>You can always send unlimited replies to user-initiated conversations.</li>
              </ul>
              <p className="mt-3" style={{ fontSize: 16, fontWeight: 400 }}>You must have a phone number that does not have a WhatsApp Account</p>
              <p style={{ fontSize: 16, fontWeight: 400 }}>For SMS Channel, You should have a registered DLT & header for ease of usage</p>
              <p style={{ fontSize: 16, fontWeight: 400 }}>For Email Channel, You should have a business email Id to share emails</p>
              {selectedPlan && (
                <div className="p-3 mt-3" style={{ border: "1px solid #ddd", borderRadius: 8 }}>
                  <p className="mb-1 fw-bold">Plan you’re opting for</p>
                  <div className="d-flex justify-content-between align-items-center p-2 border rounded mb-3">
                    <span>{`${selectedPlan?.name ?? "N/A"} plan (${selectedPlan?.duration ?? "-"})`}</span>
                    <span className="font-weight-bold" style={{ color: colors.primary03 }}>
                      {currency === "INR"
                  ? `₹${selectedPlan?.priceINR ?? 0}`
                  : `$${selectedPlan?.priceUSD ?? 0}`}
                    </span>
                  </div>
                  <small className="text-muted">
                    This will be a recurring plan which means you will be charged automatically until you cancel from your Cheerio dashboard.
                  </small>
                </div>
              )}

              <p className="mt-3 text-muted">
                Still have doubts?{" "}
                <span
                  style={{ color: colors.primary03, cursor: "pointer" }}
                  onClick={() => {
                    window.location.href =
                      "mailto:support@cheerio.freshdesk.com?subject=Contact Us";
                  }}
                >
                  Contact sales
                </span>

              </p>

            </div>

            <div className="col-md-6 p-4"
              style={{
                background: "#FFFFFF",
                borderRadius: 12,
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                marginTop: "-40px",
              }}>

              <h5 style={{ color: colors.primary03, marginBottom: 16 }}>Get Started with Cheerio Premium</h5>

              <div
                className="p-3 mb-3 custom-scroll"

                style={{
                  background: "#f3ecff",
                  borderRadius: 8,
                  height: 340,
                  overflowY: "auto",
                }}
              >
                <p className="fw-bold mb-2" style={{ color: '#5301E5' }}>What you will get:</p>

                <p className="fw-bold mt-2" style={{ color: '#5301E5' }}>Features</p>

                {planName === "Startup" && (
                  <ul className="list-unstyled" style={{ fontSize: 14, lineHeight: "26px", color: "#333" }}>
                    <li style={checkIconStyle}>
                      <span style={checkIconStyle}>✔</span>
                      All 5 Channels <br /><small>Email, SMS, WhatsApp, Instagram, RCS</small>
                    </li>
                    <li style={checkIconStyle}>
                      <span style={checkIconStyle}>✔</span>
                      WhatsApp Automation & Chatbot
                    </li>
                    <li style={checkIconStyle}>
                      <span style={checkIconStyle}>✔</span>
                      Instagram Automation & Chatbot
                    </li>
                    <li style={checkIconStyle}>
                      <span style={checkIconStyle}>✔</span>
                      AI Agents <br /><small>As per model usage</small>
                    </li>
                    <li style={checkIconStyle}>
                      <span style={checkIconStyle}>✔</span>
                      WhatsApp Team Inbox
                    </li>
                    <li style={checkIconStyle}>
                      <span style={checkIconStyle}>✔</span>
                      Instagram Inbox
                    </li>
                    <li style={checkIconStyle}>
                      <span style={checkIconStyle}>✔</span>
                      2 Agent Login <br /><small>(₹500/Add-on)</small>
                    </li>
                    <li style={checkIconStyle}>
                      <span style={checkIconStyle}>✔</span>
                      Email Manager & Automation <br /><small>(1 sender ID)</small>
                    </li>
                    <li style={checkIconStyle}>
                      <span style={checkIconStyle}>✔</span>
                      Email Sequences & Warmup
                    </li>
                    <li style={checkIconStyle}>
                      <span style={checkIconStyle}>✔</span>
                      Mobile App Inbox
                    </li>
                    <li style={checkIconStyle}>
                      <span style={checkIconStyle}>✔</span>
                      Integrations (Unlimited)
                    </li>
                    <li style={checkIconStyle}>
                      <span style={checkIconStyle}>✔</span>
                      Chat GPT Integration (Chargeable)
                    </li>
                    <p className="fw-bold mt-2" style={{ color: '#5301E5' }}>Support</p>
                    <li style={checkIconStyle}>✔ Onboarding support</li>
                    <li style={checkIconStyle}>✔ Customer Support</li>

                    <p className="fw-bold mt-2" style={{ color: '#5301E5' }}>Developer Tools</p>

                    <li style={checkIconStyle}>✔ Webhook Integration</li>

                  </ul>
                )}
                {planName === "Growth" && (
                  <ul className="list-unstyled" style={{ fontSize: 14, lineHeight: "26px", color: "#333" }}>
                    <li style={checkIconStyle}>
                      <span style={checkIconStyle}>✔</span>
                      All 5 Channels <br /><small>Email, SMS, WhatsApp, Instagram, RCS</small>
                    </li>
                    <li style={checkIconStyle}>
                      <span style={checkIconStyle}>✔</span>
                      WhatsApp Automation & Chatbot
                    </li>
                    <li style={checkIconStyle}>
                      <span style={checkIconStyle}>✔</span>
                      Instagram Automation & Chatbot
                    </li>
                    <li style={checkIconStyle}>
                      <span style={checkIconStyle}>✔</span>
                      AI Agents <br /><small>As per model usage</small>
                    </li>
                    <li style={checkIconStyle}>
                      <span style={checkIconStyle}>✔</span>
                      WhatsApp Team Inbox
                    </li>
                    <li style={checkIconStyle}>
                      <span style={checkIconStyle}>✔</span>
                      Instagram Inbox
                    </li>
                    <li style={checkIconStyle}>
                      <span style={checkIconStyle}>✔</span>
                      4 Agent Login <br /><small>(₹500/Add-on)</small>
                    </li>
                    <li style={checkIconStyle}>
                      <span style={checkIconStyle}>✔</span>
                      Meta Ads Manager
                    </li>
                    <li style={checkIconStyle}>
                      <span style={checkIconStyle}>✔</span>
                      Email Manager & Automation <br /><small>(3 sender ID)</small>
                    </li>
                    <li style={checkIconStyle}>
                      <span style={checkIconStyle}>✔</span>
                      Email Sequences & Warmup
                    </li>
                    <li style={checkIconStyle}>
                      <span style={checkIconStyle}>✔</span>
                      Embedded Forms (with watermark)
                    </li>
                    <li style={checkIconStyle}>
                      <span style={checkIconStyle}>✔</span>
                      Advance Analytics & Reports
                    </li>
                    <li style={checkIconStyle}>
                      <span style={checkIconStyle}>✔</span>
                      Mobile App Inbox
                    </li>
                    <li style={checkIconStyle}>
                      <span style={checkIconStyle}>✔</span>
                      Integrations (Unlimited)
                    </li>
                    <li style={checkIconStyle}>
                      <span style={checkIconStyle}>✔</span>
                      Chat GPT Integration (Chargeable)
                    </li>
                    <p className="fw-bold mt-2" style={{ color: '#5301E5' }}>Support</p>
                    <li style={checkIconStyle}>✔ Onboarding support</li>
                    <li style={checkIconStyle}>✔ Customer Support</li>

                    <p className="fw-bold mt-2" style={{ color: '#5301E5' }}>Developer Tools</p>

                    <li style={checkIconStyle}>✔ Webhook Integration</li>

                  </ul>
                )}
                {planName === "Pro" && (
                  <ul className="list-unstyled" style={{ fontSize: 14, lineHeight: "26px", color: "#333" }}>
                    <li style={checkIconStyle}>
                      <span style={checkIconStyle}>✔</span>
                      All 5 Channels <br /><small>Email, SMS, WhatsApp, Instagram, RCS</small>
                    </li>
                    <li style={checkIconStyle}>
                      <span style={checkIconStyle}>✔</span>
                      WhatsApp Automation & Chatbot
                    </li>
                    <li style={checkIconStyle}>
                      <span style={checkIconStyle}>✔</span>
                      Instagram Automation & Chatbot
                    </li>
                    <li style={checkIconStyle}>
                      <span style={checkIconStyle}>✔</span>
                      AI Agents <br /><small>As per model usage</small>
                    </li>
                    <li style={checkIconStyle}>
                      <span style={checkIconStyle}>✔</span>
                      WhatsApp Team Inbox
                    </li>
                    <li style={checkIconStyle}>
                      <span style={checkIconStyle}>✔</span>
                      Instagram Inbox
                    </li>
                    <li style={checkIconStyle}>
                      <span style={checkIconStyle}>✔</span>
                      8 Agent Login <br /><small>(₹500/Add-on)</small>
                    </li>
                    <li style={checkIconStyle}>
                      <span style={checkIconStyle}>✔</span>
                      Meta Ads Manager
                    </li>
                    <li style={checkIconStyle}>
                      <span style={checkIconStyle}>✔</span>
                      Email Manager & Automation <br /><small>(5 sender ID)</small>
                    </li>
                    <li style={checkIconStyle}>
                      <span style={checkIconStyle}>✔</span>
                      Email Sequences & Warmup
                    </li>
                    <li style={checkIconStyle}>
                      <span style={checkIconStyle}>✔</span>
                      Embedded Forms (No watermark)
                    </li>
                    <li style={checkIconStyle}>
                      <span style={checkIconStyle}>✔</span>
                      Advance Analytics & Reports
                    </li>
                    <li style={checkIconStyle}>
                      <span style={checkIconStyle}>✔</span>
                      Mobile App Inbox
                    </li>
                    <li style={checkIconStyle}>
                      <span style={checkIconStyle}>✔</span>
                      Integrations (Unlimited)
                    </li>
                    <li style={checkIconStyle}>
                      <span style={checkIconStyle}>✔</span>
                      Chat GPT Integration (Chargeable)
                    </li>
                    <p className="fw-bold mt-2" style={{ color: '#5301E5' }}>Support</p>

                    <li style={checkIconStyle}>✔ Onboarding support</li>
                    <li style={checkIconStyle}>✔ Customer Support</li>
                    <li style={checkIconStyle}>✔ Tech Support</li>
                    <p className="fw-bold mt-2" style={{ color: '#5301E5' }}>Developer Tools</p>
                    <li style={checkIconStyle}>✔ Developer AI Library</li>
                    <li style={checkIconStyle}>✔ Webhook Integration</li>

                  </ul>
                )}

              </div>
              {selectedPlan && (
                <>
                  {currency === "INR" ? (
                    <div>
                      <div className="d-flex justify-content-between mb-2">
                        <span>Plan Pricing</span>
                        <span>₹{planPriceINR}</span>
                      </div>

                      <div className="d-flex justify-content-between mb-2">
                        <span>GST (18%)</span>
                        <span>₹{(planPriceINR * 0.18).toFixed(2)}</span>
                      </div>

                      <div className="d-flex justify-content-between fw-bold mb-3">
                        <span>Total</span>
                        <span style={{ color: colors.black }}>
                          ₹{(planPriceINR * 1.18).toFixed(2)}
                        </span>
                      </div>
                    </div>
                  ) : (
                    <>
                      <div className="d-flex justify-content-between mb-2">
                        <span>Plan Pricing</span>
                        <span>${planPriceUSD}</span>
                      </div>
                      <div className="d-flex justify-content-between fw-bold mb-3">
                        <span>Total</span>
                        <span style={{ color: colors.black }}>
                          <span>${planPriceUSD}</span>
                        </span>
                      </div>
                    </>

                  )}

                  <CheerioButton
                    borderStyle={{ width: "100%", borderColor: colors.primary03 }}
                    textStyle={{ color: colors.white }}
                    backColor={colors.primary03}
                    btnText={"Start your premium journey"}
                    onclick={() => displayRazorpaySubscription(planId)}
                  />
                </>
              )}

              <small className="d-block text-center mt-2 text-muted">
                By continuing, you agree to our Terms of Service and Privacy Policy
              </small>
            </div>

          </div>
        </Modal.Body>
      </Modal>

      <PremiumSucess
        ModalOpen={ModalOpen}
        setModalOpen={setModalOpen}
        downloadInvoiceAction={() => generateInvoice(subscriptionId)}
      />
    </>
  );
};

export default PremiumModal;

const listTextStyle = {
  fontFamily: "Segoe UI",
  fontWeight: 400,
  fontStyle: "normal",
  fontSize: "16px",
  lineHeight: "130%",
  letterSpacing: "0%",
  color: "#666666",
  textDecorationStyle: "solid",
  textDecorationOffset: "0%",
  textDecorationThickness: "0%",
};

const checkIconStyle = {
  color: "#8E53F7",
  marginRight: 8,
};
